const RADIO_SIZE = 18;
const BOX_SHADOW_SIZE = 14;

export { RADIO_SIZE, BOX_SHADOW_SIZE };
